import { Wallet } from "@phosphor-icons/react";

export default Wallet
